import { FC } from 'react';
import { Button } from '@mui/material';
import { DownloadReportButtonProps } from './ReportDialog.props';

const DownloadReportButton: FC<DownloadReportButtonProps> = ({ isDownloading, onClick }) => (
  <Button
    data-testid="daily-nav-report-download"
    sx={{ mt: 1, textTransform: 'none' }}
    disabled={isDownloading}
    onClick={onClick}>
    Download report
  </Button>
);

export default DownloadReportButton;
